import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    console.log('AdminRoute - Current state:', {
      hasUser: !!user,
      isAdmin,
      loading,
      path: location.pathname
    });
  }, [user, isAdmin, loading, location.pathname]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-travel-primary"></div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    console.log('AdminRoute - User not authenticated or not admin, redirecting to login');
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  console.log('AdminRoute - User is authenticated and admin, rendering protected content');
  return <>{children}</>;
}